// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-documents-save-to-canopy-files-dropdown-save-to-canopy-files-dropdown-styles__component--3sI16 svg {\n  pointer-events: none;\n}\n\n.src-documents-save-to-canopy-files-dropdown-save-to-canopy-files-dropdown-styles__dropdown--1pb7G {\n  left: unset;\n  right: 0;\n  min-width: 31.0rem;\n  padding: 0;\n}", ""]);
// Exports
exports.locals = {
	"component": "src-documents-save-to-canopy-files-dropdown-save-to-canopy-files-dropdown-styles__component--3sI16",
	"dropdown": "src-documents-save-to-canopy-files-dropdown-save-to-canopy-files-dropdown-styles__dropdown--1pb7G"
};
module.exports = exports;
